import Utils from '../../services/Utils'
import {
  GApi,
  defineCancelApiObject,
  defaultHeaders,
  csvDownloadHeaders,
} from '../config/GApi'
import Download from '../../services/Download'

const DatabricksBillingApi = {
  getList: async function (cancel = false) {
    const response = await GApi.request({
      url: '/core/databricks-billing',
      method: 'GET',
      headers: defaultHeaders(),
      signal: cancel
        ? cancelApiObject[this.getList.name].handleRequestCancellation().signal
        : undefined,
    })

    Utils.ensureJson(response)

    return response.data
  },
  exportAsCsv: async function (cancel = false) {
    const response = await GApi.request({
      url: '/core/databricks-billing',
      method: 'GET',
      headers: csvDownloadHeaders(),
      signal: cancel
        ? cancelApiObject[this.exportAsCsv.name].handleRequestCancellation()
            .signal
        : undefined,
    })

    Download.csv('databricks-billing-costs.csv', response.data)
  },
}

const cancelApiObject = defineCancelApiObject(DatabricksBillingApi)

export default DatabricksBillingApi
